import { type FirebaseRepository } from '../../models/FirebaseRepository'
import { ChatController } from '../meeting/ChatController'
import { getRoomMessages } from '../../firestore/RoomMessage'
import { getRoomState } from '../../firestore/RoomState'
import { captureException } from '@sentry/core'

export class InstructorChatController extends ChatController {
  constructor({
    repository,
    roomId,
  }: {
    repository: FirebaseRepository
    roomId: string
  }) {
    super({ repository, roomId })
  }

  initialize(): void {
    this.addStream(
      getRoomState(this.repository, { roomStateId: this.roomId }),
      (roomState) => {
        this._roomState.replaceModel(roomState)
      }
    )
    this.restartRoomMessagesStream()
  }

  restartRoomMessagesStream(retryCount = 0) {
    const key = 'room-messages-stream'
    this.removeStream(key)

    this.addStream(
      getRoomMessages(this.repository, {
        roomId: this.roomId,
        schedulingBot: true,
      }),
      (messages) => {
        this.messagesCol.replaceModels(messages)
      },
      {
        name: key,
        disableCaptureException: true,
        onError: (err) => {
          this.messagesCol.changeLoadingState(true)
          if (retryCount < 5) {
            setTimeout(
              () => {
                if (this.isDisposed) return

                this.restartRoomMessagesStream(retryCount + 1)
              },
              400 * (retryCount + 1)
            )
          } else {
            console.error(err)
            captureException(err)
          }
        },
      }
    )
  }

  localStorageKey() {
    return `chat-${this.roomId}-readMessages-scheduling-instructor`
  }

  formatDate(date: Date) {
    return date.toLocaleTimeString(undefined, {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
  }

  formatDateLong(d: Date) {
    const dayOfWeek = d.toLocaleDateString(undefined, { weekday: 'long' })
    const time = d
      .toLocaleTimeString(undefined, {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      })
      .toLowerCase()
    const date = d.toLocaleDateString(undefined, {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })
    return `${dayOfWeek} ${time}, ${date}`
  }
}
